module.exports = __webpack_public_path__ + "img/logo.07ef70f7.png";